import React, { PropsWithChildren, useCallback, useEffect, useRef, useState } from "react";

import { eleResizeObserver } from "@/utils/method";

import CMPT_BarY from "../barY";
import CMPT_Ul from "../ul";

interface Props {
  height?: number;
  dataAry?: any[];
  ulClassName?: string;
  scrollBtmCb?: () => void;
  defaultWinHeight?: number;
  isDisableObserver?: boolean;
  [key: string]: any;
}

const XtScrollWindow: React.FC<PropsWithChildren<Props>> = ({
  children,
  height,
  dataAry,
  ulClassName,
  scrollBtmCb,
  defaultWinHeight = 1,
  isDisableObserver,
  ...rest
}) => {
  const [winHeight, setWinHeight] = useState<number>(defaultWinHeight);
  const [scrollTop, setScrollTop] = useState<number>(0);
  const scrollEle = useRef() as React.MutableRefObject<HTMLDivElement>;

  const timeoutResize = useRef<number>();
  const timeoutScroll = useRef<number>();

  const handleScrollY = useCallback(
    (el) => {
      if (timeoutScroll.current) return;
      timeoutScroll.current = window.setTimeout(() => {
        setScrollTop(el.scrollTop);
        timeoutScroll.current = 0;
        if (scrollBtmCb && el.scrollHeight === el.scrollTop + winHeight) {
          scrollBtmCb();
        }
      }, 20);
    },
    [scrollBtmCb, winHeight]
  );

  const onResize = useCallback(() => {
    if (timeoutResize.current) return;
    timeoutResize.current = window.setTimeout(() => {
      if (scrollEle.current) {
        setWinHeight(scrollEle.current.offsetHeight);
        setScrollTop(scrollEle.current.scrollTop);
      }
      timeoutResize.current = 0;
    }, 100);
  }, []);

  useEffect(() => {
    if (!scrollEle.current) return;
    setWinHeight(scrollEle.current.offsetHeight);
    !isDisableObserver && eleResizeObserver(scrollEle.current, onResize);

    return () => {
      timeoutResize.current && window.clearTimeout(timeoutResize.current);
      timeoutScroll.current && window.clearTimeout(timeoutScroll.current);
    };
  }, [isDisableObserver, onResize]);

  return (
    <CMPT_BarY containerRef={(ref) => (scrollEle.current = ref)} onScrollY={handleScrollY} {...rest}>
      <CMPT_Ul className={ulClassName} scrollTop={scrollTop} winHeight={winHeight} height={height} dataAry={dataAry}>
        {children}
      </CMPT_Ul>
    </CMPT_BarY>
  );
};

export default XtScrollWindow;
